import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, createProductAction } from "../../redux/actions/productActions";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import useNavHighlight from "../../hooks/useNavHighlight";
import usePageMeta from "../../hooks/usePageMeta";
import ProductForm from "./ProductForm";
import api from "../../api";
import normalizeUpc, { getNormalizeUpcError } from "../../utils/normalizeUpc";

const AddProduct = () => {
    const dispatch = useDispatch();

    const { loading, error, message } = useSelector(state => state.product);

    const [scan_code, setScan_code] = useState("");
    const [description, setDescription] = useState("");
    const [unit_case, setUnit_case] = useState("");
    const [department, setDepartment] = useState("");
    const [purchase_qty, setPurchase_qty] = useState(null);
    const [sold_qty, setSold_qty] = useState(null);
    const [adjust_qty, setAdjust_qty] = useState(null);
    const [current_qty, setCurrent_qty] = useState(null);
    const [each_cost, seteach_cost] = useState("");
    const [each_retail, seteach_retail] = useState("");
    useNavHighlight("addProduct");
    usePageMeta("addProduct");

    const lookupMaster = async (upc) => {
        if (!upc || !upc.trim()) return;
        const normalized = normalizeUpc(upc.trim());
        if (!normalized) return;
        try {
            const { data } = await api.get(`/api/v1/product/lookup-master?upc=${normalized}`);
            if (data.found) {
                if (data.item.description) setDescription(data.item.description);
                if (data.item.unit_case)   setUnit_case(data.item.unit_case);
                toast.info("Product info pre-filled from Master Price Book");
            }
        } catch {
            // silently ignore lookup errors
        }
    };

    useEffect(() => {
        setCurrent_qty((Number(purchase_qty) + Number(sold_qty) + Number(adjust_qty)) || null);
    }, [purchase_qty, sold_qty, adjust_qty]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (message) {
            toast.success(message);
            dispatch({ type: "PRODUCT_CREATE_RESET" });
            handleReset();
        }
    }, [error, message, dispatch]);

    const handleReset = () => {
        setScan_code("");
        setDescription("");
        setUnit_case("");
        setDepartment("");
        setPurchase_qty(null);
        setSold_qty(null);
        setAdjust_qty(null);
        setCurrent_qty(null);
        seteach_cost("");
        seteach_retail("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!description) { toast.error("Please enter description"); return; }
        if (!department) { toast.error("Please enter department"); return; }
        if (!each_cost || Number(each_cost) < 0) { toast.error("Please enter cost"); return; }
        console.log(Number(each_retail));
        if (!each_retail || Number(each_retail) < 0) { toast.error("Please enter retail"); return; }
        if (Number(each_cost) > Number(each_retail)) { toast.error("Cost should be less than retail"); return; }
        if (!scan_code) { toast.error("Please enter scan code"); return; }

        const normalizedCode = normalizeUpc(scan_code);
        if (!normalizedCode) {
            toast.error(getNormalizeUpcError(scan_code));
            return;
        }

        const data = {
            scan_code: normalizedCode,
            description, unit_case, department,
            purchase_qty, sold_qty, adjust_qty, current_qty,
            each_cost, each_retail
        };

        dispatch(createProductAction(data));
    };

    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax] ]">
                {loading && <Loader />}
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Add Product</h2>
                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/"}>Dashboard</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Add Product</span>
                    </div>
                </div>
            </section>

            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax] mb-[1vmax]">
                <div className="p-[2vmax_0vmax] flex justify-end">
                    <Link to="/import-products" className="bg-[var(--color-2)] hover:scale-[0.9] text-white text-[1vmax] py-[0.6vmax] px-[1vmax] rounded-[0.5vmax]">
                        Import Products
                    </Link>
                </div>
            </section>

            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax] mb-[4vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    <ProductForm
                        scan_code={scan_code} setScan_code={setScan_code}
                        description={description} setDescription={setDescription}
                        unit_case={unit_case} setUnit_case={setUnit_case}
                        department={department} setDepartment={setDepartment}
                        purchase_qty={purchase_qty} setPurchase_qty={setPurchase_qty}
                        sold_qty={sold_qty} setSold_qty={setSold_qty}
                        adjust_qty={adjust_qty} setAdjust_qty={setAdjust_qty}
                        current_qty={current_qty} setCurrent_qty={setCurrent_qty}
                        each_cost={each_cost} seteach_cost={seteach_cost}
                        each_retail={each_retail} seteach_retail={seteach_retail}
                        onSubmit={handleSubmit}
                        onReset={handleReset}
                        submitLabel="Save Product"
                        onScanBlur={lookupMaster}
                    />
                </div>
            </section>
        </Fragment>
    );
};

export default AddProduct;
